<template>
  <div>
    <base-checkbox
      v-for="option in options"
      :key="option.id"
      :name="option.name"
      :model-value="selectedIds.has(option.id)"
      @change="updateSelected(option.id, $event)"
    >
      {{ option.name }}
    </base-checkbox>
  </div>
</template>

<script lang="ts" setup>
interface SelectOption {
  name: string
  id: string
}

const props = defineProps<{
  options: SelectOption[]
}>()

const emit = defineEmits<{
  (e: 'change', value: string[]): void
}>()

const selectedIds = ref(new Set<string>())

function updateSelected(id: string, value: boolean) {
  if (value) {
    selectedIds.value.add(id)
  } else {
    selectedIds.value.delete(id)
  }
  emit('change', [...selectedIds.value])
}
</script>
